import { api } from 'pages/APIs';
import { groupCreateRequest } from 'src/types';
import AbstractApiService from 'src/services/abstractApiService';

export default class PermissionsApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getAll(params: any = {}): Promise<any> {
    const querystring = this.encodeQueryData(params);
    const url = querystring
      ? api.get_all_groups_permissions + '?' + querystring
      : api.get_all_groups_permissions;
    return super.get(url);
  }

  public async editGroup(id: string, data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }
    return super.put(
      api.roles_group_edit + id + '?org_id=' + data.org_id,
      formData,
    );
  }
  public async deleteGroupById(id: string): Promise<any> {
    return this.delete(api.roles_group_delete + id, {});
  }

  public async createGroup(data: groupCreateRequest): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.roles_group_create, formData);
  }

  public async getGroupUsers(groupId: string): Promise<any> {
    return super.get(api.get_group_users + '?group_id=' + groupId);
  }

  public async getUserGroups(): Promise<any> {
    return super.get(api.get_user_groups);
  }

  public async removeUserFromGroup(
    groupId: string,
    userId: string,
  ): Promise<any> {
    const formData = new FormData();
    formData.append('group_id', groupId);
    formData.append('user_id', userId);
    return this.delete(api.remove_user_from_group, formData);
  }

  public async addUserToGroup(
    groupId: string,
    userId: string,
    removeFromOtherGroups: boolean,
  ): Promise<any> {
    const formData = new FormData();
    formData.append('group_id', groupId);
    formData.append('user_id', userId);
    formData.append(
      'remove_from_other_groups',
      removeFromOtherGroups.toString(),
    );
    return this.post(api.add_user_to_group, formData);
  }

  public async getAllDocTypeSettings(group_id: any): Promise<any> {
    return super.get(
      api.get_all_document_types_settings + '?group_id=' + group_id,
    );
  }

  public async updateAllDocTypeSettings(jsonData: any): Promise<any> {
    return super.post(api.update_all_document_types_settings, jsonData);
  }

  public async getAllFieldsDocTypeSettings(group_id: any): Promise<any> {
    return super.get(api.get_document_type_all_field + '?group_id=' + group_id);
  }
}
